import { useState } from 'react';

export default function useForm<TForm>(initialData: TForm): UseForm<TForm> {
    const [formData, setFormData] = useState(initialData);

    function handleChange<T>(name: string, value: T) {
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    function resetData(data: TForm) {
        setFormData(data);
    }

    return [formData, handleChange, resetData];
}

type UseForm<TForm> = [
    formData: TForm,
    handleChange: <T>(name: string, value: T) => void,
    resetData: (data: TForm) => void,
];
